import { CONTENTFUL_ENV, CONTENTFUL_SPACE_ID } from '../../common/config';

export const getContentAri = (entryId: string) => {
    const contentfulSpaceId = CONTENTFUL_SPACE_ID || window.contentfulSpaceId;
    const contentfulEnv = CONTENTFUL_ENV || window.CONTENTFUL_ENV;
    return `ari:third-party:contentful::entry/${contentfulSpaceId}/${contentfulEnv}/${entryId}`;
};
